import { onLogout } from "../../../plugins/vue-apollo";

export const signOut = () => {
  onLogout();
  location.reload();
};
